import { useEffect, useState } from 'react';
import { eventDispatcher } from '@gloat/services';
import PageViewService from '../page-view';

const EventService = ({ userId, product, endpoint, credentials, apiAuthClient }) => {
  const [isInit, setIsInit] = useState(eventDispatcher.isInit || false);

  useEffect(() => {
    const unsubscribe = eventDispatcher.init({ product, userId, endpoint, credentials, apiAuthClient });

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsInit(true);

    return () => unsubscribe();
  }, [userId]);

  return isInit && <PageViewService fireEvent={payload => eventDispatcher.event(payload)} />;
};

export default EventService;
